import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { sendTemplateSms } from 'modules/accommodations/features/reservations/api';

export const useCalculationSmsTemplateMutation = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate: sendSmsTask, isLoading: isSending } = useMutation(sendTemplateSms, {
    onSuccess: () => successToast(t('SMS sent successfully.')),
    onError: () => errorToast(),
  });

  return {
    isSending,
    sendSmsTask,
  };
};
